import styled from "styled-components";

export const Line = styled.div`
    display: inline-block;
    width: 100%;
    height: .0625rem;
`